import React from "react";
import PureComponent from "../pure";
import sAction from "sAction";
import MenuButton from "./menuButton";

export default class MenuGroup extends PureComponent {
  render() {
    var colorNumber = 0;
    const data = this.props.data;
    const groupIndex = this.props.groupIndex;
    let open = this.props.open;
    const colorCount = sAction.colorTemplate.length;
    var groupWithSelectModule = false;
    const buttonsRender = data.buttons.map((button, buttonIndex) => {
      const iconColor = sAction.colorTemplate[colorNumber];
      if (colorNumber >= colorCount) {
        colorNumber = 0;
      } else {
        colorNumber += 1;
      }
      if (button.get("name") && this.props.activeModule && button.get("name").toLowerCase() == this.props.activeModule.toLowerCase()) {
        groupWithSelectModule = true;
      }
      return (
        <MenuButton
          key={buttonIndex}
          // iconColor={'#262836'}
          iconColor={iconColor}
          index={buttonIndex}
          activeModule={this.props.activeModule}
          way={"menu/groups/" + groupIndex + "/buttons/" + buttonIndex}
          ref={button.name}
          button={button}
          menuOpen={this.props.menuOpen}
        />
      );
    });

    var extraClass = "menuGroup";
    if (groupWithSelectModule) {
      extraClass += " select";
    }

    let permanentlyOpen = false;
    // set first group Business to be permanently open
    if (this.props.data?.get("name") === "LBL_TABGROUP_ACTIVITIES") {
      permanentlyOpen = true;
      open = true;
    }

    if (this.props.menuOpen === true || permanentlyOpen === true) {
      return (
        <div>
          {this.props.oneGroup || (
            <div
              onClick={() => sAction.toggleMenuGroup(groupIndex)}
              className={extraClass + (open ? " open" : "")}
            >
              <div>
              <span className={"icon-" + data.icon} />
              {sAction.translate(data.name)}
              </div>
              <div className="menuGroupOpenIndicator">
                {permanentlyOpen ? <div></div>
                : <div className={open ? "icon-subpanelClose" : "icon-subpanelOpen"} />}
              </div>
            </div>
          )}
          <div className={"menuGroupItems" + (open ? " fullHeight" : "")}>
            {buttonsRender}
          </div>
        </div>
      );
    } else {
      return <>{buttonsRender}</>;
    }
  }
}
